import type { NumberDropdownFormFieldProps } from '@zealth/core/formFields/types'

import { DropdownFormField } from './DropdownFormField'

export { type NumberDropdownFormFieldProps }

export const NumberDropdownFormField = ({
  options,
  label,
  optional,
}: NumberDropdownFormFieldProps) => (
  <DropdownFormField<number | null>
    options={options}
    label={label}
    optional={optional}
    deserialize={raw => (raw === '' ? null : parseInt(raw, 10))}
  />
)
